import { Component, inject } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';

import { HeaderComponent } from './shared/header/header';
import { FooterComponent } from './shared/footer/footer';
import { ReportWidgetComponent } from './shared/report-widget/report-widget';
import { SeoData, SeoService } from './core/seo/seo.service';
import { ThemeService } from './core/theme/theme.service';

function collectRouteData(snapshot: ActivatedRouteSnapshot): Record<string, unknown> {
  let data: Record<string, unknown> = { ...snapshot.data };
  if (snapshot.firstChild) {
    data = { ...data, ...collectRouteData(snapshot.firstChild) };
  }
  return data;
}

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, FooterComponent, ReportWidgetComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  constructor() {
    inject(ThemeService); // activates the theme effect on startup
    const router = inject(Router);
    const seo = inject(SeoService);

    router.events
      .pipe(
        filter(e => e instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe(() => {
        const data = collectRouteData(router.routerState.snapshot.root);
        seo.update((data['seo'] as SeoData) ?? {});
      });
  }
}
